
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Besttaxiserviceinmumbai() {



    const cardData =
    {
        keyword: ' Best Taxi Service in Mumbai',
        heading: 'Deva Cabs:  Best Taxi Service in Mumbai',
        headingDescription: 'Deva Cabs is proud to be recognized as one of the best taxi services in Mumbai, offering reliable, comfortable, and professional transportation across the city and beyond. Whether you need a ride for daily commuting, airport transfers, corporate travel, or outstation trips, our fleet of well-maintained vehicles and courteous drivers ensure a smooth and stress-free journey. Known for punctuality, transparent pricing, and excellent customer support, Deva Cabs caters to solo travelers, families, and business clients with equal care. With 24/7 service and a wide range of vehicle options, we deliver the best taxi experience Mumbai has to offer.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "The Gateway of India is Mumbai’s most iconic landmark, built in 1924 to commemorate the visit of King George V and Queen Mary. Standing 26 meters tall on the waterfront in Colaba, it features Indo-Saracenic architecture and overlooks the Arabian Sea. Tourists flock here for ferry rides to Elephanta Caves, street snacks, and the beautiful view of the Taj Mahal Palace Hotel nearby. It’s a favorite photo spot and a symbol of Mumbai’s colonial legacy."
  },
  {
    "title": "Marine Drive",
    "location": "South Mumbai, Maharashtra",
    "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Lined with Art Deco buildings and palm trees, it’s a favorite spot for evening strolls, joggers, and sunset watchers. The Chowpatty Beach at the northern end is famous for Mumbai street food. At night, the street lights along the curve resemble a sparkling necklace, giving it its popular nickname."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "location": "Fort, Mumbai, Maharashtra",
    "description": "CST, formerly known as Victoria Terminus, is a UNESCO World Heritage Site and one of India’s busiest railway stations. Built in 1887, it features Victorian Gothic Revival architecture mixed with Indian influences. The grand domes, pointed arches, turrets, and stained glass make it a masterpiece of colonial-era construction. It’s also a central hub for Mumbai’s suburban and long-distance trains."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "Located on Elephanta Island, about an hour’s ferry ride from the Gateway of India, these 5th–8th century rock-cut caves are a UNESCO World Heritage Site. The main attraction is the 20-foot-tall Trimurti sculpture of Lord Shiva. The island is serene, with stone steps leading through souvenir shops, monkeys, and views of the sea. It’s a perfect half-day historical excursion."
  },
  {
    "title": "Juhu Beach",
    "location": "Juhu, Mumbai, Maharashtra",
    "description": "Juhu Beach is one of the most popular beaches in Mumbai, known for its vast sandy shoreline, street food stalls, and vibrant crowds. It's a favorite hangout spot for locals, celebrities, and tourists. Activities include horse rides, kite flying, and enjoying bhel puri or pav bhaji by the sea. The beach becomes especially festive during Ganesh Visarjan and sunset hours."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Built in 1431, Haji Ali Dargah is a revered Islamic shrine situated on a small islet off the Worli coast. It houses the tomb of Pir Haji Ali Shah Bukhari and is connected to the mainland by a narrow causeway. The white-domed mosque is both a spiritual center and architectural wonder, attracting people of all faiths for blessings and scenic views of the Arabian Sea."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Spanning over 100 square kilometers, Sanjay Gandhi National Park is a green lung within the city. It’s home to leopards, deer, monkeys, and over 250 species of birds. Attractions include a lion and tiger safari, boating, the toy train Vanrani, and the 2,000-year-old Kanheri Caves carved into basalt rock. It’s a peaceful escape for nature lovers and families."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "location": "Mumbai, Maharashtra",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge that connects Mumbai’s western suburbs to South Mumbai. Officially named the Rajiv Gandhi Sea Link, it stretches 5.6 km and offers breathtaking views of the sea and skyline. The bridge symbolizes modern Mumbai and is best admired at night when it’s lit up beautifully. It’s not open to pedestrians but is a scenic route by car."
  },
  {
    "title": "Chor Bazaar",
    "location": "Grant Road, Mumbai, Maharashtra",
    "description": "Chor Bazaar, meaning 'Thieves’ Market', is one of the oldest and most famous flea markets in Mumbai. Located near Grant Road, it’s a paradise for antique lovers and bargain hunters. From vintage Bollywood posters and furniture to brassware, gramophones, and spare car parts—you’ll find a fascinating mix of old and odd. It’s a must-visit for collectors and those looking for quirky souvenirs."
  },
  {
    "title": "Global Vipassana Pagoda",
    "location": "Gorai, Mumbai, Maharashtra",
    "description": "The Global Vipassana Pagoda is a large Buddhist meditation center near Gorai Creek. Standing 96 meters tall, it houses the world’s largest stone dome built without supporting pillars. The golden stupa is a symbol of peace and harmony and offers free Anapana meditation sessions for visitors. Surrounded by water and greenery, it’s an ideal spot for spiritual retreat and quiet reflection."
  }
],



  "services": [
    {
      "name": "Best Taxi Service in Mumbai",
      "description": "Deva Cabs offers the best taxi service in Mumbai with a focus on punctuality, cleanliness, safety, and affordability. Whether you're commuting daily, heading to the airport, or planning an outstation trip, our diverse fleet caters to every travel need. Our drivers are background-verified, courteous, and trained to provide a professional travel experience. With transparent pricing and 24x7 customer support, we ensure your ride across Mumbai is smooth and reliable. Enjoy door-to-door pickup, real-time booking, and hassle-free payments — making Deva Cabs the trusted choice among Mumbai residents and visitors alike."
    },
    {
      "name": "Top Cab Providers in Mumbai",
      "description": "Looking for the top cab companies in Mumbai? Deva Cabs ranks among the city's most preferred taxi providers thanks to our wide network, quality vehicles, and dependable chauffeurs. We offer a seamless booking experience, instant confirmations, and vehicles ranging from hatchbacks to luxury sedans. Whether it’s a quick local ride or a multi-day journey, our focus is always on quality, safety, and service excellence."
    },
    {
      "name": "Reliable Taxi Service Mumbai",
      "description": "Reliability is at the heart of Deva Cabs’ services. With on-time arrivals, professional drivers, and well-maintained vehicles, our taxi service in Mumbai ensures peace of mind for every journey. Whether you're heading to a business meeting, picking someone up from the airport, or exploring the city, trust Deva Cabs for consistent and dependable travel solutions."
    },
    {
      "name": "Affordable Cab Hire Mumbai",
      "description": "Deva Cabs offers affordable cab hire options across Mumbai, making quality taxi services accessible to everyone. Our pricing is transparent with no hidden charges, and we provide multiple packages to suit your needs — hourly, point-to-point, or full-day rentals. Book an AC cab at competitive rates without compromising comfort or safety."
    },
    {
      "name": "Online Cab Booking Mumbai",
      "description": "Booking a cab in Mumbai has never been easier with Deva Cabs' online platform. Choose your pickup and drop locations, vehicle type, and travel date — all in just a few clicks. Our website and app offer real-time availability, instant booking confirmations, secure payments, and 24/7 customer support to make your travel experience seamless."
    },
    {
      "name": "Airport Taxi Mumbai",
      "description": "Catch your flight stress-free with Deva Cabs’ dedicated airport taxi service in Mumbai. We provide reliable pickups and drop-offs to both Domestic and International terminals with real-time flight tracking and buffer timing for delays. Our drivers are trained to handle airport transfers with utmost punctuality and professionalism."
    },
    {
      "name": "Outstation Cab Mumbai",
      "description": "Planning a weekend getaway or business trip? Deva Cabs offers comfortable and dependable outstation cabs from Mumbai to all major destinations in Maharashtra and beyond. Choose from one-way or round-trip packages, select your preferred car (Sedan, SUV, Tempo Traveller), and travel with peace of mind backed by experienced drivers and 24/7 support."
    },
    {
      "name": "Luxury Taxi Rental Mumbai",
      "description": "Upgrade your travel experience with our luxury taxi rental service in Mumbai. Ideal for corporate events, weddings, VIP travel, or a stylish city tour, our premium cars include high-end sedans and SUVs. With chauffeur-driven comfort, leather interiors, and smooth rides, our luxury fleet ensures you travel in elegance and style."
    },
    {
      "name": "Local Cab Service Mumbai",
      "description": "Need a cab for errands, shopping, office commute, or school drops? Our local cab service in Mumbai is designed for daily travel needs. Choose hourly rental or point-to-point transfers with professional drivers who know the city's roads and traffic patterns. Flexible and economical options make Deva Cabs your go-to local travel partner."
    },
    {
      "name": "Mumbai City Cab Tour",
      "description": "Discover the charm of Mumbai with our city cab tours, tailored for tourists and locals alike. Visit iconic spots like Marine Drive, Gateway of India, Siddhivinayak Temple, and more in a clean, AC cab with an experienced local chauffeur. Book half-day or full-day city tours online and explore Mumbai at your own pace."
    },
    {
      "name": "Family Cab Hire Mumbai",
      "description": "Travel safely with your loved ones in our spacious and family-friendly cabs. Deva Cabs offers sedan and SUV rentals in Mumbai perfect for family outings, functions, and long drives. Our vehicles come with ample luggage space, child seat options, and courteous chauffeurs who prioritize your family’s comfort and safety."
    },
    {
      "name": "Corporate Taxi Service Mumbai",
      "description": "Deva Cabs provides professional corporate taxi services in Mumbai tailored for business executives, daily commutes, and intercity travel. We offer fixed monthly billing, on-demand cabs, and luxury vehicle options to suit your company’s image and employees' comfort. Our trained chauffeurs ensure punctuality, discretion, and excellent service throughout."
    },
    {
      "name": "Premium Cab Service Mumbai",
      "description": "Enjoy top-tier service with our premium cab offerings in Mumbai. From high-end vehicles to priority support, our premium service ensures a smooth and classy experience for business travelers, tourists, and VIP clients. Whether it's a local ride or an outstation journey, Deva Cabs delivers excellence at every turn."
    },
    {
      "name": "24x7 Taxi Booking Mumbai",
      "description": "Need a taxi late at night or early morning? Deva Cabs is available round the clock for your convenience. Our 24x7 booking service ensures you’re never stranded — book a cab anytime via app, website, or phone and enjoy fast, reliable service anywhere in Mumbai, day or night."
    },
    {
      "name": "Chauffeur-driven Cab Mumbai",
      "description": "Sit back and relax with Deva Cabs’ chauffeur-driven cab service in Mumbai. Our professional drivers are trained, courteous, and familiar with the city’s routes, ensuring a comfortable ride every time. Whether you need a cab for business meetings, airport transfers, or a day-long city tour, our chauffeur service adds a touch of class to your journey."
    }
  ],
  "tableData": [
    ["Best Taxi Service in Mumbai", "-Top Cab Providers in Mumbai"],
    ["Reliable Taxi Service Mumbai", "-Affordable Cab Hire Mumbai"],
    ["Online Cab Booking Mumbai", "-Airport Taxi Mumbai"],
    ["Outstation Cab Mumbai", "-Luxury Taxi Rental Mumbai"],
    ["Local Cab Service Mumbai", "-Mumbai City Cab Tour"],
    ["Family Cab Hire Mumbai", "-Corporate Taxi Service Mumbai"],
    ["Premium Cab Service Mumbai", "-24x7 Taxi Booking Mumbai"],
    ["Chauffeur-driven Cab Mumbai", "-Best Taxi Service in Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Trusted and Reliable Taxi Service in Mumbai",
    "WhyChoosedescription": "Deva Cabs is known for its punctuality and dependability. Whether you need a quick city ride or a long-distance trip, our taxis arrive on time and get you to your destination safely and promptly, every time."
  },
  {
    "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
    "WhyChoosedescription": "Choose from a diverse fleet including sedans, SUVs, and premium cars, all regularly serviced and sanitized. Our vehicles are clean, comfortable, and equipped with modern amenities to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are thoroughly vetted, trained, and committed to providing courteous and safe service. With their excellent knowledge of Mumbai’s roads and traffic patterns, they ensure a smooth and hassle-free journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront pricing with no hidden charges. Whether you book a local trip, airport transfer, or outstation ride, our fare structure is clear and fair, giving you complete peace of mind."
  },
  {
    "WhyChooseheading": "24/7 Availability for All Your Travel Needs",
    "WhyChoosedescription": "Deva Cabs operates round the clock, providing taxi services throughout Mumbai day and night. No matter the time, you can rely on us for prompt and convenient transportation."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your taxi effortlessly using our mobile app, website, or customer support. Enjoy instant confirmations, flexible payment options, and real-time driver tracking for a seamless experience."
  },
  {
    "WhyChooseheading": "Customer-Centric Service with Support Anytime",
    "WhyChoosedescription": "Our dedicated customer care team is available 24/7 to assist you with bookings, route information, and special requests. Your satisfaction and comfort are our top priorities."
  },
  {
    "WhyChooseheading": "Customized Travel Solutions",
    "WhyChoosedescription": "Whether you need hourly rentals, one-way rides, round trips, or corporate travel solutions, Deva Cabs offers flexible packages tailored to your schedule and preferences."
  }
]
















    }




const faqData = [
  {
    question: "Why is Deva Cabs considered one of the best taxi services in Mumbai?",
    answer: "Deva Cabs is known for its punctuality, clean vehicles, professional drivers, transparent pricing, and round-the-clock availability. We strive to deliver a consistently superior travel experience across Mumbai."
  },
  {
    question: "What areas in Mumbai are covered by Deva Cabs?",
    answer: "We operate across all major areas of Mumbai including South Mumbai, Western Suburbs, Eastern Suburbs, Navi Mumbai, and Thane. Our services cover both local and outstation travel."
  },
  {
    question: "What types of taxis does Deva Cabs offer in Mumbai?",
    answer: "We provide a wide range of vehicle options including hatchbacks, sedans, SUVs, and premium cars for every type of travel need—solo, family, corporate, or leisure."
  },
  {
    question: "Is Deva Cabs available 24/7 in Mumbai?",
    answer: "Yes, our taxi services are available 24 hours a day, 7 days a week. Whether it’s a late-night drop or an early morning pick-up, we’re always ready."
  },
  {
    question: "How can I book a taxi with Deva Cabs in Mumbai?",
    answer: "You can book easily through our website, mobile app, or by calling our customer support. Booking is quick, transparent, and confirmation is instant."
  },
  {
    question: "Are the drivers of Deva Cabs experienced and verified?",
    answer: "Absolutely. All drivers are professionally trained, background-verified, and well-acquainted with Mumbai routes to ensure a safe and pleasant ride."
  },
  {
    question: "What are the payment options with Deva Cabs?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments via our secure platform. Choose the option that’s most convenient for you."
  },
  {
    question: "Can I pre-schedule a taxi ride with Deva Cabs?",
    answer: "Yes, you can schedule your ride in advance to avoid last-minute hassle. Just choose your date, time, and pickup location while booking."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Arjun Kulkarni',
    role: 'Daily Commuter',
    review: 'Deva Cabs is hands down the best taxi service in Mumbai. Always on time, clean cars, polite drivers — everything you expect from a professional service.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Riya Mehta',
    role: 'Frequent Traveler',
    review: 'I’ve used multiple taxi services in Mumbai but Deva Cabs stands out for its reliability and smooth booking experience. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];




































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Taxi Service in Mumbai",
  "image": "https://devacab.com/assets/images/best-taxi-service-in-mumbai.jpg", // Replace with actual image URL
  "description": "Deva Cabs offers the best taxi service in Mumbai with reliable, affordable, and chauffeur-driven cabs. Book online for airport transfers, outstation trips, city tours, corporate travel, and family rides. Available 24x7 with luxury and economy options.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // Example starting price, update if needed
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/best-taxi-service-in-mumbai" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Best Taxi Service in Mumbai | Reliable & Affordable Cabs | Deva Cabs</title>
  <meta
    name="description"
    content="Book the best taxi service in Mumbai with Deva Cabs. Reliable, affordable, and chauffeur-driven cabs for airport transfers, outstation trips, city tours, corporate & family travel. 24x7 online booking available."
  />
  <meta
    name="keywords"
    content="Best Taxi Service in Mumbai, Top cab providers Mumbai, Reliable taxi service Mumbai, Affordable cab hire Mumbai, Online cab booking Mumbai, Airport taxi Mumbai, Outstation cab Mumbai, Luxury taxi rental Mumbai, Local cab service Mumbai, Mumbai city cab tour, Family cab hire Mumbai, Corporate taxi service Mumbai, Premium cab service Mumbai, 24x7 taxi booking Mumbai, Chauffeur-driven cab Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/74.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Besttaxiserviceinmumbai;